// packages/shared/src/config/algolia.ts

export interface AlgoliaConfiguration {
  appId: string;
  searchApiKey: string; // Public search-only API key
  indices: {
    courts: string;
  };
}

// Configuration with environment variables for security
// Note: import.meta.env is only available in Vite environments (web package)
// The shared package should only use process.env or have defaults
export const algoliaConfig: AlgoliaConfiguration = {
  // Use process.env for Node.js compatibility, fallback to empty string
  appId: process.env.REACT_APP_ALGOLIA_APP_ID ||  '',
  searchApiKey: process.env.REACT_APP_ALGOLIA_SEARCH_API_KEY || '',
  indices: {
    courts: process.env.REACT_APP_ALGOLIA_INDEX_NAME || process.env.REACT_APP_ALGOLIA_INDEX_NAME || 'courts',
  },
};

// Validation function to ensure configuration is valid
export const validateAlgoliaConfig = (): boolean => {
  const { appId, searchApiKey, indices } = algoliaConfig;
  
  if (!appId) {
    console.error('Algolia App ID is missing. Please set REACT_APP_ALGOLIA_APP_ID or VITE_ALGOLIA_APP_ID environment variable.');
    return false;
  }
  
  if (!searchApiKey) {
    console.error('Algolia Search API Key is missing. Please set REACT_APP_ALGOLIA_SEARCH_API_KEY or VITE_ALGOLIA_SEARCH_API_KEY environment variable.');
    return false;
  }
  
  if (!indices.courts) {
    console.error('Algolia Courts Index name is missing. Please set REACT_APP_ALGOLIA_INDEX_NAME or REACT_APP_ALGOLIA_INDEX_NAME environment variable.');
    return false;
  }
  
  return true;
};

// Index configuration for sorting replicas
export const algoliaIndexConfig = {
  courts: {
    primary: 'courts',
    replicas: {
      name_asc: 'courts_name_asc',
      name_desc: 'courts_name_desc',
      price_asc: 'courts_price_asc',
      price_desc: 'courts_price_desc',
      total_asc: 'courts_total_asc',
      total_desc: 'courts_total_desc',
    }
  }
};

// Facet configuration for search
export const algoliaFacetConfig = {
  searchableFacets: [
    'location.city',
    'location.country',
    'details.facility_type',
    'details.court_surface',
    'pricing.category'
  ],
  filterOnlyFacets: [
    'details.lights',
    'details.indoor_courts'
  ]
};